import styled, { createGlobalStyle } from "styled-components";
import { ColorProps, GlobalColorPalette } from "@gago/frame";
import headerIcon from "./header-icon.svg";

// tslint:disable:variable-name
export const HomeHeaderBody = styled.div<ColorProps<GlobalColorPalette>>`
  height: 100%;
  width: 100%;
  background-color: #161616;
  background-image: url("/static/images/bg.png");
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
  .menu-box{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    .menu-icon{
      position: absolute;
      top: 16px;
      left: 16px;
      z-index: 9;
      height: 24px;
      width: 24px;
      cursor: pointer;
      background-image: url("${headerIcon}");
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
  .content-body{
    height: 100%;
    width: 100%;
  }
`;
export const AntdPopoverStyle = createGlobalStyle<ColorProps<GlobalColorPalette>>`
  .andhome-popover{
    .ant-popover-content{
      .ant-popover-arrow{
        border-top-color: #00cae0 !important;
        border-left-color: #00cae0 !important;
      }
      .ant-popover-inner{
        background-color: #051621;
        border-radius: 6px;
        border: 1px solid #00cae0;
        .ant-popover-inner-content{
          padding: 0;
          color: #00cae0;
        }
      }
    }
    .popover-box{
      padding: 16px;
      .pb-title{
        height: 14px;
        line-height: 1;
        color: #00cae0;
      }
      .router-box{
        padding-top: 4px;
        .route-item{
          display: block;
          padding: 0 24px;
          margin-top: 12px;
          width: 100%;
          height: 48px;
          line-height: 46px;
          border-top: 1px solid rgb(0 229 255 / 35%);
          border-bottom: 1px solid rgb(0 229 255 / 35%);
          background-color: rgb(0 229 255 / 15%);
          font-size: 16px;
          color: #00cae0;
          position: relative;
          transition: all 0.25s ease-out;
          &:hover{
            color: #c2fffa;
            border-top-color: rgb(0 229 255 / 45%);
            border-bottom-color: rgb(0 229 255 / 45%);
          }
        }
        .r-active{
          color: #ffcc00;
          border-top-color: rgb(245 127 69 / 45%);
          border-bottom-color: rgb(245 127 69 / 45%);
          background-color: rgb(245 127 69 / 15%);
          &::after{
            content: "";
            position: absolute;
            z-index: 22;
            bottom: -1px;
            left: 0px;
            height: 1px;
            width: 100%;
            background-color: rgb(245 127 69 / 45%);
            background-image: radial-gradient(circle at 50% 50%, rgb(255, 255, 255), rgba(27, 83, 147, 0) 66%), linear-gradient(#f57f45, #f57f45);
          }
          &:hover{
            color: #ffcc00;
            border-top-color: rgb(245 127 69 / 45%);
            border-bottom-color: rgb(245 127 69 / 45%);
            background-color: rgb(245 127 69 / 15%);
          }
        }
      }
      .timing-function{
        margin-top: 12px;
        height: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .tf-label{
          font-size: 12px;
        }
        .ant-switch {
          border-color: #009fb8;
          border-radius: 8px;
        }
      }
      .user-box{
        margin-top: 24px;
        height: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .user-name{
          font-size: 12px;
        }
        .logout-box{
          font-size: 12px;
          cursor: pointer;
          user-select: none;
          .logout-value{
            margin-left: 3px;
          }
        }
      }
    }
  }
`;
